import { get, axiosErrorHandler } from '../../shared/helpers/axiosInstance';
import { ZapsignDocument } from '../interfaces/zapsign.interface';

const baseLoanPath = '/v1/zapsign';

export const getDocument = async (id: string): Promise<ZapsignDocument> => {
	try {
		const res = await get<ZapsignDocument>(`${baseLoanPath}/doc/${id}`);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
